module.exports = __webpack_public_path__ + "img/print_template_conasi.4db75faf.svg";